import image1 from '../assets/images/image1.jpg';
import image2 from '../assets/images/image2.jpg';
import image3 from '../assets/images/image3.jpg';

export const featuredProperties = [
  {
    id: 1,
    title: "Braverock Park Estate Villa",
    price: "₦45,000,000",
    location: "Braverock Park, Gombe",
    beds: 4,
    baths: 3,
    area: "250m²",
    image: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde",
    description: "Luxurious villa in the prestigious Braverock Park Estate.",
    coordinates: [11.172, 10.284],
    type: "luxury",
    investment_score: 8,
    growth: 10
  },
  {
    id: 2,
    title: "Modern Apartment in Maitama",
    price: "₦75,000,000",
    location: "Maitama District, Abuja",
    beds: 3,
    baths: 2,
    area: "150m²",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9",
    description: "Spacious apartment with modern amenities in the heart of Maitama.",
    coordinates: [7.498, 9.082],
    type: "residential",
    investment_score: 7,
    growth: 8
  },
  {
    id: 3,
    title: "Luxury Villa in Asokoro",
    price: "₦120,000,000",
    location: "Asokoro District, Abuja",
    beds: 5,
    baths: 4,
    area: "300m²",
    image: image2,
    description: "Elegant villa with premium finishes in prestigious Asokoro.",
    coordinates: [7.526, 9.045],
    type: "luxury",
    investment_score: 8,
    growth: 12
  },
  {
    id: 4,
    title: "Office Space in Central Business District",
    price: "₦45,000,000",
    location: "CBD, Abuja",
    beds: null,
    baths: 2,
    area: "200m²",
    image: image3,
    description: "Prime office space in Abuja's business hub.",
    coordinates: [7.498, 9.027],
    type: "commercial",
    investment_score: 9,
    growth: 15
  },
  {
    id: 5,
    title: "Luxury Penthouse in Jabi",
    price: "₦180,000,000",
    location: "Jabi District, Abuja",
    beds: 4,
    baths: 4,
    area: "350m²",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c",
    description: "Stunning penthouse with panoramic city views.",
    coordinates: [7.425, 9.082],
    type: "luxury",
    investment_score: 9,
    growth: 14
  },
  {
    id: 6,
    title: "Garden Apartment in Wuse",
    price: "₦65,000,000",
    location: "Wuse Zone 6, Abuja",
    beds: 2,
    baths: 2,
    area: "120m²",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
    description: "Modern apartment with beautiful garden views.",
    coordinates: [7.459, 9.072],
    type: "residential",
    investment_score: 6,
    growth: 7
  },

  {
    id: 7,
    title: "Modern Townhouse in GRA",
    price: "₦35,000,000",
    location: "GRA, Gombe",
    beds: 3,
    baths: 2,
    area: "180m²",
    image: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b",
    description: "Contemporary townhouse in Gombe's prime location.",
    coordinates: [11.169, 10.287],
    type: "residential",
    investment_score: 7,
    growth: 9
  },
  {
    id: 8,
    title: "Oceanfront Apartment in Eko Atlantic",
    price: "₦250,000,000",
    location: "Eko Atlantic, Lagos",
    beds: 3,
    baths: 3,
    area: "200m²",
    image: "https://images.unsplash.com/photo-1600573472592-401b489a3cdc",
    description: "Luxury apartment with stunning ocean views.",
    coordinates: [3.404, 6.419],
    type: "luxury",
    investment_score: 9,
    growth: 15
  },
  {
    id: 9,
    title: "Modern Villa in Lekki Phase 1",
    price: "₦180,000,000",
    location: "Lekki Phase 1, Lagos",
    beds: 5,
    baths: 4,
    area: "400m²",
    image: "https://images.unsplash.com/photo-1600047509358-9dc75507daeb",
    description: "Spacious family home in prestigious Lekki.",
    coordinates: [3.475, 6.431],
    type: "luxury",
    investment_score: 8,
    growth: 12
  },
  {
    id: 10,
    title: "Executive Home in Millennium City",
    price: "₦85,000,000",
    location: "Millennium City, Kaduna",
    beds: 4,
    baths: 3,
    area: "300m²",
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d",
    description: "Modern family home in secure estate.",
    coordinates: [7.509, 10.469],
    type: "residential",
    investment_score: 7,
    growth: 8
  },
  {
    id: 11,
    title: "Garden Estate Villa in Barnawa",
    price: "₦65,000,000",
    location: "Barnawa, Kaduna",
    beds: 3,
    baths: 2,
    area: "250m²",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3",
    description: "Beautiful villa with extensive gardens.",
    coordinates: [7.440, 10.482],
    type: "residential",
    investment_score: 6,
    growth: 7
  },
  {
    id: 12,
    title: "Waterfront Mansion in Old GRA",
    price: "₦150,000,000",
    location: "Old GRA, Port Harcourt",
    beds: 6,
    baths: 5,
    area: "500m²",
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d",
    description: "Luxurious mansion with waterfront views.",
    coordinates: [7.050, 4.816],
    type: "luxury",
    investment_score: 8,
    growth: 11
  },
  {
    id: 13,
    title: "Modern Apartment in Peter Odili",
    price: "₦55,000,000",
    location: "Peter Odili Road, Port Harcourt",
    beds: 3,
    baths: 2,
    area: "150m²",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
    description: "Contemporary apartment in prime location.",
    coordinates: [7.080, 4.789],
    type: "residential",
    investment_score: 7,
    growth: 9
  }
];
